import React, { useEffect } from "react";
import { ChevronLeft } from "react-bootstrap-icons";
import BootstrapTable from "react-bootstrap-table-next";
import { useNavigate, useParams } from "react-router-dom";
import { useTemplateShowQuery } from "../../../graphql/template.hooks";
import { Spinner } from "react-bootstrap";

export const ShowTemplate = () => {
  const navigate = useNavigate();
  const { templateId } = useParams();
  const { data: template, loading: templateLoading } = useTemplateShowQuery({
    variables: { id: +templateId },
  });

  useEffect(() => {
    document.title = "View Template";
  }, []);

  const numericSort = (a: any, b: any, order: any) => {
    if (order === "asc") {
      return a - b;
    }
    return b - a;
  };

  const textSort = (a: any, b: any, order: any) => {
    if (order === "asc") {
      return a.localeCompare(b);
    }
    return b.localeCompare(a);
  };

  const columns = [
    { dataField: "id", text: "ID", sort: true, sortFunc: numericSort },
    {
      dataField: "img",
      text: "Preview",
      formatter: (cell: any) => (
        <img
          src={cell?.length < 200 ? `https://cdn2.me-qr.com/${cell}` : cell}
          alt="Preview"
          style={{ width: "109px" }}
        />
      ),
    },
    { dataField: "name", text: "Name", sort: true, sortFunc: textSort },
    {
      dataField: "content",
      text: "Content",
      sort: true,
      style: {
        maxWidth: "192px",
      },
      formatter: (cell: any) => <p className="text-break">{cell}</p>,
      sortFunc: textSort,
    },
    {
      dataField: "isCommon",
      text: "Common",
    },
    {
      dataField: "users",
      text: "Users",
      formatter: (cell: any) => (
        <div>
          {cell?.map((user: any, index: any) => (
            <span
              key={index}
              className="bg-black fs-7 text-white rounded-5 d-flex align-items-center justify-content-center"
              style={{ width: "40px", height: "40px" }}
            >
              {user}
            </span>
          ))}
        </div>
      ),
    },
  ];

  const backToList = () => {
    navigate("/template");
  };

  if (templateLoading) {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="mb-4">
        <h1>View Template</h1>
        <div
          onClick={backToList}
          className="d-flex align-items-center"
          style={{ cursor: "pointer" }}
        >
          <ChevronLeft className="me-1" size={18} color="#3A83F6" />
          <p className="text-primary m-0">To All Templates</p>
        </div>
      </div>
      <div className="g-4 py-5 px-3 d-flex flex-column justify-content-center align-items-center bg-white rounded">
        <BootstrapTable
          classes="templatesTable"
          bootstrap4
          keyField="id"
          data={[template.templateShow]}
          columns={columns}
          bordered={false}
          striped
          hover
          remote={false}
        />
      </div>
    </div>
  );
};
